import { render, staticRenderFns } from "./FrontWorkerIdentificationDocument.vue?vue&type=template&id=1e587883&scoped=true"
import script from "./FrontWorkerIdentificationDocument.vue?vue&type=script&lang=js"
export * from "./FrontWorkerIdentificationDocument.vue?vue&type=script&lang=js"
import style0 from "./FrontWorkerIdentificationDocument.vue?vue&type=style&index=0&id=1e587883&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e587883",
  null
  
)

export default component.exports